define('collections/payment/membership-plans',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api',
    // models
    'models/payment/membership-plan'
], function(
    // libs
    _, Backbone, U, API,
    // model
    MMembershipPlan
) {

    var CMembershipPlans = Backbone.Collection.extend({
        url: API.url("payments/membership/"),
        model: MMembershipPlan,
        comparator: function(model) {
            return model.getCurrencies().CAD.price;
        },

        initialize: function(models, opt) {
            this.readyPromise = Backbone.$.Deferred();
        },

        parse: function(data, opt) {
            return CMembershipPlans.__super__.parse.call(this, data, opt);
        },

        ready: function() {
            return this.readyPromise;
        }
    });

    return CMembershipPlans;
});

